export default "__VITE_ASSET__BYbRHy2h__"